export default "__VITE_ASSET__Coszortx__"